import type { IApiMessageResponse } from '@/services';

export const mapApiMessage = (data: Readonly<IApiMessageResponse>) => {
  return {
    id: data.id,
    title: data.title,
    subject: data.subject,
    body: data.body,
    imageUrl: data.imageUrl,
    dateTime: new Date(data.dateTime),
    isRead: data.isRead
  };
};
